// LEGACY: Uses SCSS with CSS modules. New code should use @metarouter-private/mr-mui components instead.
import React from 'react';

import GetSchemaSummary from 'app/event-monitoring/event-schemas/get-schema-summary';
import Header from 'app/event-monitoring/event-schemas/header';
import EventSchemaTable from 'app/event-monitoring/event-schemas/EventSchemaTable';
import ReportPanel from 'app/event-monitoring/event-schemas/panel';
import NewSchemaReport from 'app/event-monitoring/event-schemas/new-report';
import useEventSchemasState from 'app/event-monitoring/event-schemas/state';
import MrTabPanelBase from 'app/components/MrTabPanelBase';

import s from './header/index.module.scss';

export default function EventSchemasPage() {
  const state = useEventSchemasState();

  return (
    <>
      {!state.cluster && (
        <MrTabPanelBase>
          <div className={s.container}>
            <NewSchemaReport
              updateReportSettings={state.updateReportSettings}
              onClose={() => {}}
              cluster={state.cluster}
            />
          </div>
        </MrTabPanelBase>
      )}
      {state.cluster && (
        <MrTabPanelBase
          header={
            <Header
              cluster={state.cluster}
              earliestSeen={state.earliestSeen}
              timeframeHours={state.timeframeHours}
              reports={state.reports}
              resetReports={state.resetReports}
            />
          }
        >
          <>
            <GetSchemaSummary
              cluster={state.cluster}
              earliestSeen={state.earliestSeen}
              timeframeHours={state.timeframeHours}
              setSchemaSummary={state.setReports}
              setReportsError={state.setReportsError}
              setLoadingSummary={state.loadingReports}
            />
            <EventSchemaTable
              loading={state.isLoadingReports}
              reports={state.reports}
              reportsError={state.reportsError}
              setSelectedReport={state.setSelectedReport}
              selectedReport={state.selectedReport}
            />
            {/* TODO: bb - replace with mui drawer in separate MR */}
            {state.selectedReport && (
              <ReportPanel
                cluster={state.cluster}
                earliestSeen={state.earliestSeen}
                timeframeHours={state.timeframeHours}
                report={state.selectedReport}
                clearReport={() => state.setSelectedReport(null)}
              />
            )}
          </>
        </MrTabPanelBase>
      )}
    </>
  );
}
